import classNames from "classnames";
import { FC, ReactNode } from "react";
import { MdArrowForward, MdPersonOutline, MdSwapHoriz } from "react-icons/md";
import Tag from "@Components/Decor/Tag";
import Chip from "@Components/Decor/Chip";
import { CorrectIcon } from "@Icons/MainIcons";

type TransferCardProps = {
  title: ReactNode;
  subtitle: ReactNode;
  sender: ReactNode;
  amountLabel: ReactNode;
  amount: ReactNode;
  unit: ReactNode;
  status: ReactNode;
  className?: string;
};

const TransferCard: FC<TransferCardProps> = ({ title, subtitle, sender, amountLabel, amount, unit, status, className }) => {
  return (
    <div className={classNames("bg-background-default flex w-64 flex-col gap-4 rounded-lg p-5 shadow-lg", className)}>
      <Tag
        className="bg-transparent! p-0! shadow-none!"
        title={<span className="text-sm">{title}</span>}
        subtitle={subtitle}
        icon={<MdSwapHoriz className="bg-background-primary h-full w-full rounded-full p-2 text-white" />}
      />
      <div className="flex items-center gap-1">
        <div className="bg-background-primary-lighter text-font-active flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-xs font-semibold">
          {sender}
        </div>
        <div className="border-border-subtle flex-1 border-t-2 border-dashed" />
        <div className="bg-background-primary flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-white">
          <MdArrowForward className="h-3 w-3 rtl:-scale-x-100" />
        </div>
        <div className="border-border-subtle flex-1 border-t-2 border-dashed" />
        <div className="bg-background-minimal text-icon-subtle flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
          <MdPersonOutline className="h-5 w-5" />
        </div>
      </div>
      <div className="flex items-end justify-between">
        <span className="text-font-subtle text-xs">{amountLabel}</span>
        <span className="text-font-default text-xl font-bold">
          {amount} <span className="text-font-subtle text-xs font-normal">{unit}</span>
        </span>
      </div>
      <Chip
        title={status}
        icon={<CorrectIcon className="h-3 w-3" />}
        className="bg-background-success! text-font-success! px-2! text-xs! outline-none!"
      />
    </div>
  );
};

export default TransferCard;
